import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAccountStore } from '@/store';

const useAdminGuard = () => {
  const navigate = useNavigate();
  const isAdminRootPath = location.pathname === '/admin';
  const isAdminPath = location.pathname.startsWith('/admin');
  const isAdmin = useAccountStore(
    (s) => !!s?.permissions?.can_view_back_office
  );

  useEffect(() => {
    if (!isAdminPath) return;

    if (!isAdmin) {
      // navigate('/404', { replace: true });
    } else if (isAdminRootPath) {
      navigate('/admin/users');
    }
  }, [isAdminPath, isAdminRootPath, isAdmin, navigate]);

  return {
    isAdmin,
    isAdminPath,
  };
};

export default useAdminGuard;
